import { camelCaseToSnakeCase, snakeCaseToCamelCase } from './string'

export interface BaseObject {
  [key: string]: any
}

/**
 *
 * @param input Objet at camelCase
 * @returns New object with keys in snake_case
 */
export function camelCaseObjectToSnakeCase<T extends BaseObject>(input: T) {
  const output: any = {}

  for (const [key, value] of Object.entries(input) as [keyof T, any][]) {
    delete output[key]
    output[(camelCaseToSnakeCase(key as string) as keyof T) || key] = value
  }
  return output
}

/**
 *
 * @param input Object at snake_case
 * @returns New object with keys in camelCase
 */
export function snakeCaseObjectToCamelCase(input: BaseObject) {
  const output: BaseObject = {}

  for (const [key, value] of Object.entries(input)) {
    delete output[key]
    output[snakeCaseToCamelCase(key) || key] = value
  }
  return output
}

export function omit<T extends Record<string, any>, K extends keyof T>(
  input: T,
  keys: K[],
): Omit<T, K> {
  const output: Partial<T> = {}

  for (const [key, value] of Object.entries(input) as [K, T[K]][]) {
    if (!keys.includes(key)) {
      output[key] = value
    }
  }
  return output as Omit<T, K>
}

export function pick<T extends Record<string, any>, K extends keyof T>(
  input: T,
  keys: K[],
): Pick<T, K> {
  const output: Partial<T> = {}

  for (const key of keys) {
    output[key] = input[key]
  }
  return output as Pick<T, K>
}
